import { constants } from '../config';

const initialState = {
  done: false,
  loading: false,
  errorRequest: false,
  error: null,
  info: {},
};

export default function setProductsByCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case constants.GET_PRODUCTS_BY_CATEGORY:
      return { ...state, loading: true, errorRequest: false, error: null };
    case constants.GET_PRODUCTS_BY_CATEGORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        done: true,
        info: {
          ...action.payload,
        },
      };
    }
    case constants.GET_PRODUCTS_BY_CATEGORY_FAIL:
      return { ...state, loading: false, errorRequest: true, error: { ...action.error } };

    case constants.RESET_PRODUCTS_BY_CATEGORY:
      return initialState;
    default:
      return state;
  }
}
